import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowUpMdFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.4743 3.52051C9.80161 3.25355 10.2841 3.27238 10.5892 3.57747L15.5893 8.57747C15.9146 8.90292 15.9147 9.43047 15.5893 9.75586C15.2639 10.0812 14.7363 10.0811 14.4109 9.75586L10.8334 6.17839V15.8333C10.8333 16.2935 10.4602 16.6666 10 16.6667C9.53984 16.6667 9.16678 16.2935 9.16668 15.8333V6.17839L5.58917 9.75586C5.26377 10.0812 4.7362 10.0811 4.41078 9.75586C4.08536 9.43044 4.0854 8.90292 4.41078 8.57747L9.41082 3.57747L9.4743 3.52051Z",
		fill: "currentColor"
	})
});
export default SvgArrowUpMdFill;
